import AccountingMenu from '../components/AccountingMenu';
import CallCenterSalesMenu from '../components/CallCenterSalesMenu';
import LineAssignmentsMenu from '../components/LineAssignmentsMenu';
import LineReportsMenu from '../components/LineReportsMenu';
import MarketingMenu from '../components/MarketingMenu';
import SalesReportsSimMenu from '../components/SalesReportsSimMenu';
import ShippingMenu from '../components/ShippingMenu';
import SuppliersMenu from '../components/SuppliersMenu';
import SupportTicketsMenu from '../components/SupportTicketsMenu';
// import SuppliersIPBMenu from "../components/paymentSuppliersIPBMenu";
import IFTReportsMenu from '../components/IFTReportsMenu';
import MtcenterMenu from '../components/MtcenterMenu';
import PortabilityReportsMenu from '../components/PortabilityReportsMenu';

export const menusConfig = [
  {
    ListItemComponent: SupportTicketsMenu,
    key: 'support',
    openProp: 'openMenuSupport',
    handleClickProp: 'handleClickSupport',
  },
  {
    ListItemComponent: CallCenterSalesMenu,
    key: 'sales',
    openProp: 'openMenuSales',
    handleClickProp: 'handleClickSales',
  },
  {
    ListItemComponent: AccountingMenu,
    key: 'accounting',
    openProp: 'openMenuAccounting',
    handleClickProp: 'handleClickMenuAccounting',
  },
  {
    ListItemComponent: MarketingMenu,
    key: 'marketing',
    openProp: 'openMenuMarketing',
    handleClickProp: 'handleClickMarketing',
  },
  {
    ListItemComponent: SalesReportsSimMenu,
    key: 'reportsSales',
    openProp: 'openMenuReportsSales',
    handleClickProp: 'handleClickReportsSales',
  },
  {
    ListItemComponent: LineReportsMenu,
    key: 'reportsLines',
    openProp: 'openMenuReportsLines',
    handleClickProp: 'handleClickReportsLines',
  },
  {
    ListItemComponent: PortabilityReportsMenu,
    key: 'reportsPortability',
    openProp: 'openMenuReportsPortability',
    handleClickProp: 'handleClickReportsPortability',
  },
  {
    ListItemComponent: IFTReportsMenu,
    key: 'reportsIft',
    openProp: 'openMenuReportsIft',
    handleClickProp: 'handleClickReportsIft',
  },
  {
    ListItemComponent: SuppliersMenu,
    key: 'suppliers',
    openProp: 'paymentSuppliers',
    handleClickProp: 'handleOpenSuppliers',
    extraProps: {
      propName: 'paymentSuppliers',
    },
  },
  // {
  //   Component: SuppliersIPBMenu,
  //   key: "suppliersIPB",
  //   openProp: "paymentSuppliersIPB",
  //   handleClickProp: "handleOpenSuppliersIPB",
  //   extraProps: {
  //     propName: "paymentSuppliersIPB",
  //   },
  // },
  {
    ListItemComponent: MtcenterMenu,
    key: 'directory',
    openProp: 'openMenuMTCenter',
    handleClickProp: 'handleOpenMTCenter',
  },
  {
    ListItemComponent: ShippingMenu,
    key: 'shipping',
    openProp: 'openShipping',
    handleClickProp: 'handleClickShipping',
  },
  {
    ListItemComponent: LineAssignmentsMenu,
    key: 'lineAssignments',
    openProp: 'openLineAssignments',
    handleClickProp: 'handleClickLineAssignments',
  },
];
